import { FileService } from '@/service';

/**
 * @class @name Content
 * @description Exposes menu store module
 */
export default class File {
	/**
	 * @method @static @get @name namespaced
	 * @description Is this module namespaced?
	 */
	static get namespaced() {
		return true;
	}

	/**
	 * @method @static @get @name state
	 * @description Expose state as an object, compatible with vue stores
	 */
	static get state() {
		return {};
	}

	/**
	 * @method @static @get @name getters
	 * @description Expose getters as an object, compatible with vue stores
	 */
	static get getters() {
		return {};
	}

	/**
	 * @method @static @get @name mutations
	 * @description Expose mutations as an object, compatible with vue stores
	 */
	static get mutations() {
		return {};
	}

	/**
	 * @method @static @get @name actions
	 * @description Expose action as an object, compatible with vue stores
	 */
	static get actions() {
		return {
			/**
			 * @async @name get
			 * @param {Object} context
			 * @param {Object} payload
			 */
			getFile(context, payload) {
				let { s3Key, filename } = payload;
				return FileService.get(s3Key, filename);
			},

			/**
			 * @async @name getAssetFile
			 * @param {Object} context
			 * @param {Object} payload
			 */
			getAssetFile(context, payload) {
				let { s3Key, filename } = payload;
				return FileService.getAsset(s3Key, filename);
			}
		};
	}
}
